/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <i className="fas fa-home"></i>
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        <li
          className={`menu-item ${getMenuItemActive("/marketing", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/marketing">
            <span className="svg-icon menu-icon">
              <i className="fa fa-globe"></i>
            </span>
            <span className="menu-text">Marketing Materials</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive("/merchants", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/merchants">
            <span className="svg-icon menu-icon">
              <i className="fas fa-user-friends"></i>
            </span>
            <span className="menu-text">Merchants</span>
          </NavLink>
        </li>

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/category",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/category">
            <span className="svg-icon menu-icon">
              <i className="fas fa-layer-group"></i>
            </span>
            <span className="menu-text">Platform Categories</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Platform Categories</span>
                </span>
              </li>
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/category"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/category">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Shopify Categories</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/wix-categories"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/wix-categories" >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Wix Categories</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::3 Level*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/woocommerce-categories"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/woocommerce-categories">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Woocommerce Categories</span>
                </NavLink>
              </li>
              {/*end::3 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/product-sync", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/product-sync">
            <span className="svg-icon menu-icon">
              <i className="fas fa-sync-alt"></i>
            </span>
            <span className="menu-text">Products Sync</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/shopify-price",
            true
          )} ${getMenuItemActive(
            "/wix-price",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/e-commerce">
            <span className="svg-icon menu-icon">
              <i className='fas fa-dollar-sign'></i>
            </span>
            <span className="menu-text">Platform Pricing</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {/* <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">eCommerce</span>
                </span>
              </li> */}
              {/*begin::2 Level*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/shopify-price"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/shopify-price">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Shopify</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              {<li
                className={`menu-item ${getMenuItemActive(
                  "/wix-price"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/wix-price">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Wix</span>
                </NavLink>
              </li>}
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              {/* <li
                className={`menu-item ${getMenuItemActive(
                  "/wix-price"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/wix-price"  style={{cursor:'not-allowed'}}>
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Wix Price</span>
                </NavLink>
              </li> */}
              {/*end::2 Level*/}
              {/*begin::3 Level*/}
              {/* <li
                className={`menu-item ${getMenuItemActive(
                  "/wocommerce-price"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/wocommerce-price"  style={{cursor:'not-allowed'}}>
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Wocommerce Price</span>
                </NavLink>
              </li> */}
              {/*end::3 Level*/}
              {/*begin::4 Level*/}
              {/* <li
                className={`menu-item ${getMenuItemActive(
                  "/cart-price"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/cart-price">
                  <i className="menu-bullet menu-bullet-dot" >
                    <span />
                  </i>
                  <span className="menu-text">Bigcommerce Price</span>
                </NavLink>
              </li> */}
              {/*end::4 Level*/}
            </ul>
          </div>
        </li>
        
        <li
          className={`menu-item ${getMenuItemActive("/activity", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/activity">
            <span className="svg-icon menu-icon">
              <i className="fas fa-history"></i>
            </span>
            <span className="menu-text">Activity</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive("/main-setting", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/main-setting">
            <span className="svg-icon menu-icon">
              <i className="fa fa-cog"></i>
            </span>
            <span className="menu-text">Settings</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive("/help", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/help">
            <span className="svg-icon menu-icon">
              <i className="fas fa-question-circle"></i>
            </span>
            <span className="menu-text">Help</span>
          </NavLink>
        </li>

      </ul>

    </>
  );
}
